/**
 * Prompt User to Login Card Component
 * Displays a card encouraging non-authenticated users to sign up or login.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const PromptUserToLoginCard = () => {
  return (
    <div className="login-prompt-card">
      <div className="login-prompt-icon"><Sparkles size={48} /></div>
      <h3 className="login-prompt-title">Join the Community</h3>
      <p className="login-prompt-text">
        Create an account to share your creative writing and connect with other writers.
      </p>
      <div className="login-prompt-actions">
        <Link to="/register" className="btn-signup">
          Sign Up
        </Link>
        <Link to="/login" className="btn-login">
          Login
        </Link>
      </div>
    </div>
  );
};

export default PromptUserToLoginCard;
